<template>
  <el-row :gutter="16" class="p-4 report" style="direction: rtl">
    <el-col :md="24" class="report-title">
      <b>گزارش عملکرد چاه ها</b>
    </el-col>

    <!-- انتخاب ناحیه -->
    <el-col :xs="24" :sm="12" :md="4">
      <el-form label-position="top">
        <el-form-item label="ناحیه مد نظر">
          <SelectWithMultiLabel
            v-model="selectedArea"
            :options="deviceStore.groupedDevices"
            value-key="area_id"
            label-key="name"
            placeholder="انتخاب ناحیه"
            multi-text="چندین ناحیه"
            :include-all="deviceStore.groupedDevices.length > 1"
            all-label="همه نواحی"
            popper-class="report-dropdown"
          />
        </el-form-item>
      </el-form>
    </el-col>

    <!-- انتخاب چاه -->
    <el-col :xs="24" :sm="12" :md="4">
      <el-form label-position="top">
        <el-form-item label="لیست چاه ها">
          <SelectWithMultiLabel
            v-model="selectedWell"
            :options="wells.map((w) => w.data)"
            value-key="device_id"
            label-key="name"
            placeholder="انتخاب چاه"
            multi-text="چندین چاه"
            :disabled="selectedArea.length !== 1"
            :include-all="wells.length > 1"
            all-label="همه چاه‌ها"
            all-value="0"
            popper-class="report-dropdown"
          />
        </el-form-item>
      </el-form>
    </el-col>

    <!-- بازه تاریخی -->
    <el-col :xs="24" :sm="24" :md="6">
      <el-form label-position="top">
        <el-form-item label="بازه تاریخی">
          <date-picker
            v-model="dateRange"
            type="date"
            range
            format="jYYYY/jMM/jDD"
            display-format="jD jMMMM jYYYY"
            placeholder="انتخاب بازه تاریخ"
            style="width: 100%; direction: ltr"
            auto-submit
            color="#205685"
          />
        </el-form-item>
      </el-form>
    </el-col>

    <!-- ساعت شروع و پایان -->
    <el-col :xs="24" :sm="24" :md="6">
      <el-row :gutter="8">
        <el-col :span="12" >
          <el-form label-position="top">
            <el-form-item label="ساعت شروع">
              <el-time-picker
                v-model="startTime"
                placeholder="ساعت شروع"
                format="HH:mm"
                
                value-format="HH:mm"
                style="width: 100%; direction: ltr"
               :disabled="!isTimePickerEnabled"

              />
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <el-form label-position="top">
            <el-form-item label="ساعت پایان">
              <el-time-picker
                v-model="endTime"
                placeholder="ساعت پایان"
                format="HH:mm"
                value-format="HH:mm"
                style="width: 100%; direction: ltr"
              />
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-col>

    <el-col
      :xs="24"
      :sm="24"
      :md="4"
      style="text-align: right; padding-right: 10px"
    >
      <el-button
        type="primary"
        class="btn-search"
        @click="search"
        :loading="loading"
      >
        جستجو
      </el-button>
    </el-col>

    <!-- چارت‌ها -->

    <el-row v-loading="loading" style="width: 100%">
      <el-col
        :xs="24"
        :sm="24"
        :md="24"
        :lg="24"
        v-for="(chart, idx) in preparedCharts"
        :key="idx + chart.title"
        style="margin-bottom: 20px"
      >
        <el-card shadow="hover">
          <BaseChart
            :type="chart.type"
            :title="chart.title"
            :categories="chart.categories"
            :data="chart.data"
            :mode="chart.mode"
            :report="true"
            :isMobile="isMobile"
            :height="chartHeight"
          />
        </el-card>
      </el-col>
    </el-row>
    <el-row v-if="commandList">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" style="margin-bottom: 20px">
        <table-command :data="commandList" />
      </el-col>
    </el-row>
  </el-row>
</template>

<script setup>
import {
  ref,
  onMounted,
  computed,
  onBeforeUnmount,
  watch,
  nextTick,
} from "vue";
import DatePicker from "vue3-persian-datetime-picker";
import { useDeviceStore } from "@/stores/device";
import { showToast } from "@/utils/toastHelper";
import {
  fetchReportFlowmeter,
  fetchReportCommandCount,
  fetchReportCommandList,
} from "@/services/auth";
import BaseChart from "@/components/BaseChart.vue";
import TableCommand from "@/components/CommandList.vue";
import jmoment from "moment-jalaali";
import SelectWithMultiLabel from "@/components/SelectWithMultiLabel.vue";

const deviceStore = useDeviceStore();
const dateRange = ref([]);
const startTime = ref("00:00");
const endTime = ref("23:59");
const selectedArea = ref([]);
const selectedWell = ref([]);
const wells = ref([]);
const commandData = ref([]);
const chartData = ref([]);
const loading = ref(false);
const commandList = ref(null);
const diffDate = ref(null);
const chartHeight = ref("450px");
const isMobile = ref(false);
const reportType = ref(0);
const checkMobile = () => {
  isMobile.value = window.innerWidth <= 768;
  chartHeight.value = isMobile.value ? "250px" : "450px";
};
const isTimePickerEnabled = computed(() => diffDate.value != null && diffDate.value == 0);

onMounted(() => {
  window.addEventListener("resize", checkMobile);
  checkMobile();
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", checkMobile);
});
onMounted(() => {
  const activeDevice = deviceStore.activeDevice;
  if (activeDevice) {
    const foundArea = deviceStore.groupedDevices.find(
      (area) => area.area_id === activeDevice.area_id
    );
    if (foundArea) {
      selectedArea.value = [activeDevice.area_id];
      wells.value = foundArea.items;

      // بعد از اینکه wells آماده شد، selectedWell ست شود
      nextTick(() => {
        if (
          foundArea.items.some(
            (w) => w.data.device_id === activeDevice.device_id
          )
        ) {
          selectedWell.value = [activeDevice.device_id];
        } else {
          selectedWell.value = [];
        }
      });
    }
  }
});

// وقتی ناحیه‌ها تغییر کرد
watch(selectedArea, (areaIds) => {
  if (!areaIds || areaIds.length === 0 || areaIds.includes("all")) {
    wells.value = [];
    selectedWell.value = [];
    return; // فقط وابسته‌ها رو ست کن
  }

  if (areaIds.length === 1) {
    const foundArea = deviceStore.groupedDevices.find(
      (area) => area.area_id === areaIds[0]
    );
    wells.value = foundArea ? foundArea.items : [];
    selectedWell.value = [];
  } else {
    wells.value = [];
    selectedWell.value = [];
  }
});

watch(
  dateRange,
  (newVal) => {
    // اطمینان از اینکه هر دو تاریخ موجود باشن
    if (newVal && newVal[0] && newVal[1]) {
      // تبدیل به moment جلالی
      const m1 = jmoment(newVal[0], "jYYYY/jMM/jDD");
      const m2 = jmoment(newVal[1], "jYYYY/jMM/jDD");

      // اختلاف روزها
      diffDate.value = Math.abs(m2.diff(m1, "days"));
      startTime.value = "00:00";
    } else {
      diffDate.value = null;
    }
  },
  { deep: true }
);

function validate() {
  let message = "";
  if (dateRange.value.length === 0) message += "انتخاب تاریخ الزامی است.<br>";
  if (
    message === "" &&
    dateRange.value[0] === dateRange.value[1] &&
    startTime.value >= endTime.value
  ) {
    message += "ساعت شروع باید کوچکتر از ساعت پایان باشد<br>";
  }
  if (!selectedArea.value.length) {
    message += "انتخاب ناحیه الزامی است.<br>";
  }

  // اگر ناحیه انتخاب شده تنها یک یا چندتا است (ولی همه نیست) و چاه انتخاب نشده
  if (
    !selectedArea.value.includes("all") &&
    selectedArea.value.length === 1 &&
    !selectedWell.value.length
  ) {
    message += "انتخاب چاه الزامی است<br>";
  }

  if (message != "") {
    showToast(message, "error");
    return false;
  }
  return true;
}

// ==== اصلاح شده: fetch + آماده سازی چارت‌ها ====
async function search() {
  if (!validate()) return;

  // تبدیل به moment جلالی
  //const m1 = jmoment(dateRange.value[0], "jYYYY/jMM/jDD");
  //const m2 = jmoment(dateRange.value[1], "jYYYY/jMM/jDD");

  // اختلاف روز
  //diffDate.value = m2.diff(m1, "days");

  loading.value = true;
//  commandData.value = [];
//  chartData.value = [];

  let ids = [];

  if (selectedArea.value.includes("all") || selectedArea.value.length > 1) {
    if (selectedArea.value.includes("all")) {
      ids = deviceStore.groupedDevices.map((area) => area.area_id);
    } else {
      ids = [...selectedArea.value];
    }
    reportType.value = 1;
  } else {
    reportType.value = 0;
    const foundArea = deviceStore.groupedDevices.find(
      (area) => area.area_id === selectedArea.value[0]
    );

    if (!selectedWell.value.length) {
      ids = [];
    } else if (selectedWell.value.some((v) => v === 0)) {
      // گزینه "همه چاه‌ها" انتخاب شده → مستقیم تمام device_id واقعی
      ids = foundArea ? foundArea.items.map((d) => d.data.device_id) : [];
    } else {
      // چاه‌های مشخص انتخاب شده
      ids = selectedWell.value.filter((v) => v != 0); // مطمئن شو هیچ 0 اضافه نشده
    }
  }

  try {
    const flow = await fetchReportFlowmeter({
      ids,
      reportType: reportType.value,
      type: 5,
      startDate: dateRange.value[0],
      endDate: dateRange.value[1],
      startTime: startTime.value,
      endTime: endTime.value,
    });
    if (diffDate.value != 0) {
      const command = await fetchReportCommandCount({
        ids,
        reportType: reportType.value,
        type: 5,
        startDate: dateRange.value[0],
        endDate: dateRange.value[1],
        startTime: startTime.value,
        endTime: endTime.value,
      });
      commandData.value = command.data.list;
    } else commandData.value = [];

    chartData.value = flow.data.list;

    if (reportType.value == 0) {
      const commandTable = await fetchReportCommandList({
        ids,
        reportType: reportType.value,
        type: 5,
        startDate: dateRange.value[0],
        endDate: dateRange.value[1],
        startTime: startTime.value,
        endTime: endTime.value,
      });
      commandList.value = commandTable.data;
    }
  } catch (error) {
    //console.error("خطا در دریافت داده:", err);
    //showToast("خطا در دریافت داده از سرور", "error");
    if (error.response && error.response.status === 401) {
      deviceStore.reset();
      window.location.href = "/login";
    } else {
      console.error("خطای دیگر:", error);
    }
  } finally {
    loading.value = false;
  }
}
function replaceDashWithSpace(str = "") {
  return String(str).replace(/-/g, " ");
}
function deleteDashWithSpace(str = "") {
  return String(str).replace(/-/g, "").trim();
}
// ==== آماده سازی چارت‌ها ====
function prepareChartData(chartData, commandData) {
  const charts = [];
  let mode = "monthly";
  /*if (diffDate.value == 0 && reportType.value==0) {
    // تبدیل لیست دستگاه‌ها به فرمت item.series
    const item = {
      series: chartData.value.map((d) => ({
        name: d.deviceName,
        xAxis: d.xAxis,
        yAxis: d.yAxis,
      })),
    };

    const allCategoriesSet = new Set();
    item.series.forEach((s) => {
      s.xAxis?.forEach((d) => allCategoriesSet.add(d));
    });
    const allCategories = Array.from(allCategoriesSet).sort(); // مرتب‌سازی زمانی

    charts.push({
      type: "line",
      mode: "daily",
      title: "مصرف روزانه آب",
      categories: allCategories.map(String), // محور X نمودار
      data: item.series.map((s) => ({
        name: replaceDashWithSpace(s.name),
        data: s.yAxis || [],
        categories: s.xAxis?.map(String) || [],
        unit: "لیتر/ثانیه",
      })),
    });

    return charts; // حتماً return کن که بقیه کد اجرا نشه
  }*/
  let waterUnit = "مترمکعب";
  if (diffDate.value <= 31) mode = "yearly";
  if (diffDate.value == 0) {
    mode = "daily";
    waterUnit = "مترمکعب/ساعت";
  }

  const chartList = Array.isArray(chartData.value) ? chartData.value : [];
  const commandList = Array.isArray(commandData.value) ? commandData.value : [];

  if (!chartList.length && !commandList.length && mode != "daily")
    return charts;

  if (!chartList.length && mode == "daily") return charts;

  const commandMapByTitle = new Map();
  const commandMapByMonth = new Map();
  if (mode != "daily") {
    commandList.forEach((item) => {
      if (item.type === "month" && item.monthKey !== undefined) {
        commandMapByMonth.set(item.monthKey, item);
      } else if (item.title) {
        commandMapByTitle.set(deleteDashWithSpace(item.title), item);
      }
    });
  }

  chartList.forEach((item) => {
    let dataSeries = [];

    switch (item.type) {
      case "total":
        if (mode != "daily") {
          const consumptionTotal = commandMapByTitle.get(item.title);
          dataSeries = [
            { name: "مصرف آب", data: item.yAxis || [], unit: waterUnit },
            {
              name: "کارکرد",
              data: consumptionTotal?.yAxis || [],
              unit: "ساعت",
            },
          ];
        } else {
          dataSeries = [
            { name: "مصرف آب", data: item.yAxis || [], unit: waterUnit },
          ];
        }
        charts.push({
          type: "bar",
          mode: mode,
          title: item.title,
          categories: item.xAxis || [],
          data: dataSeries,
        });
        break;

      case "month":
        if (mode != "daily") {
          const consumptionMonth = commandMapByMonth.get(item.monthKey);
          dataSeries = [
            { name: "مصرف آب", data: item.yAxis || [], unit: waterUnit },
            {
              name: "کارکرد",
              data: consumptionMonth?.yAxis || [],
              unit: "ساعت",
            },
          ];
        } else {
          dataSeries = [
            { name: "مصرف آب", data: item.yAxis || [], unit: waterUnit },
          ];
        }

        charts.push({
          type: "bar",
          mode: "custom",
          title: item.title,
          categories: item.xAxis || [],
          data: dataSeries,
        });
        break;

      case "multi-line":
        if (item.series && item.series.length) {
          const allCategoriesSet = new Set();
          item.series.forEach((s) => {
            s.xAxis?.forEach((d) => allCategoriesSet.add(d));
          });
          const allCategories = Array.from(allCategoriesSet).sort(); // مرتب‌سازی زمانی
          charts.push({
            type: "line",
            mode: mode,
            title: item.title.trim(), // فاصله‌ها حذف شوند
            categories: allCategories.map(String), // محور X نمودار
            data: item.series.map((s) => ({
              name: replaceDashWithSpace(s.name),
              data: s.yAxis || [],
              categories: s.xAxis?.map(String) || [],
              unit: waterUnit,
            })),
          });
        }
        break;

      default:
        if (item.type.startsWith("all-")) {
          if (mode != "daily") {
            const consumptionAll = commandMapByTitle.get(
              deleteDashWithSpace(item.title)
            );
            dataSeries = [
              { name: "مصرف آب", data: item.yAxis || [], unit: waterUnit },
              {
                name: "کارکرد",
                data: consumptionAll?.yAxis || [],
                unit: "ساعت",
              },
            ];
          } else {
            dataSeries = [
              { name: "مصرف آب", data: item.yAxis || [], unit: waterUnit },
            ];
          }
          charts.push({
            type: "bar",
            mode: "custom",
            title: item.title,
            categories: item.xAxis || [],
            data: dataSeries,
          });
        }

        break;
    }
  });
  if (mode != "daily") {
    commandList.forEach((item) => {
      if (item.type === "multi-line" && item.series && item.series.length) {
        const allCategoriesSet = new Set();
        item.series.forEach((s) => {
          s.xAxis?.forEach((d) => allCategoriesSet.add(d));
        });
        const allCategories = Array.from(allCategoriesSet).sort(); // مرتب‌سازی زمانی
        charts.push({
          type: "line",
          mode: mode,
          title: item.title.trim(), // مثلا "مصرف آب"
          categories: allCategories.map(String), // محور X نمودار
          data: item.series.map((s) => ({
            name: replaceDashWithSpace(s.name),
            data: s.yAxis || [],
            categories: s.xAxis?.map(String) || [],
            unit: "ساعت",
          })),
        });
      }
    });
  }
  loading.value = false;
  return charts;
}

// reactive computed برای template
const preparedCharts = computed(() => prepareChartData(chartData, commandData));
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.7);
  z-index: 9999;
}

.el-col {
  margin-bottom: 3px;
}
.report-title {
  text-align: right;
  margin-bottom: 30px !important;
  margin-top: 20px;
}
::v-deep(.vpd-input-group input) {
  border: 1px solid #dadada !important;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.el-col {
  margin-bottom: 3px;
}
::v-deep(.el-form-item--label-top .el-form-item__label) {
  text-align: right !important;
  font-weight: 600 !important;
  font-size: 13px !important;
}
.btn-search {
  margin-top: 30px;
  width: 65%;
}

@media screen and (max-width: 768px) {
  .btn-search {
    margin-top: 3px;
    width: 100%;
  }
}

.el-select-dropdown__item {
  padding: 0 !important;
}
::v-deep(.el-select-dropdown__item) {
  padding: 0 !important;
}
</style>
